<script setup>
// Shown over a page opened with ?viewAs=visitor: the admin is looking at the
// locked layout a visitor gets, not their own member view.
const route = useRoute();
const exitTo = computed(() => {
  const query = {...route.query};
  delete query.viewAs;
  return {path: route.path, query};
});
</script>

<template>
  <div class="tl-card vp-banner mb-4">
    <v-icon size="20" color="primary">mdi-eye-outline</v-icon>
    <div class="vp-text">
      <div class="vp-title">You're seeing this page as a visitor</div>
      <div class="vp-sub">This is what someone who is not in the club sees. Buttons are shown but not live.</div>
    </div>
    <v-btn variant="outlined" size="small" rounded="pill" :to="exitTo">Back to my view</v-btn>
  </div>
</template>

<style scoped lang="scss">
.vp-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-color: rgb(var(--v-theme-primary));
  background: rgb(var(--v-theme-brandTint));
}

.vp-text {
  flex: 1 1 auto;
  min-width: 0;
}

.vp-title {
  font-size: 13.5px;
  font-weight: 700;
}

.vp-sub {
  font-size: 11.5px;
  color: rgb(var(--v-theme-charcoal));
}

@media (max-width: 600px) {
  .vp-banner {
    flex-wrap: wrap;
  }
  .vp-banner .v-btn {
    margin-left: 32px;
  }
}
</style>
